import 'bootstrap/dist/css/bootstrap.min.css'; // Import Bootstrap CSS
import './App.css'; // Custom styles for button animation

import React, { useEffect, useState } from 'react';

// Main App component
function App() {
  const [launchSuccess, setLaunchSuccess] = useState(false); // Track if launch is successful
  const [loadingProgress, setLoadingProgress] = useState(0); // Track loading bar progress
  const [launchStarted, setLaunchStarted] = useState(false); // Track if launch process has started

  // Function to handle the button click and start loading bar
  const handleLaunchClick = () => {
    setLaunchStarted(true); // Mark launch as started
    let progress = 0;
    const loadingInterval = setInterval(() => {
      progress += 10;
      setLoadingProgress(progress);
      if (progress === 100) {
        clearInterval(loadingInterval);
        setLaunchSuccess(true); // Mark launch as successful after loading completes
      }
    }, 500); // Increase loading speed by adjusting the interval
  };

  // Redirect to the website after launch success
  useEffect(() => {
    if (launchSuccess) {
      // Redirect to the specified URL after a successful launch
      setTimeout(() => {
        window.location.href = 'https://exposition.lk/';
      }, 2000); // Delay redirect to let the success message show for 2 seconds
    }
  }, [launchSuccess]);

  return (
    <div className="App">
      <h1 className="mb-5">Magazine Launch</h1>

      {/* Container for the swipe button and loading bar */}
      <div className="swipe-button-container">
        {!launchStarted && !launchSuccess ? (
          <button
            className="swipe-button btn btn-warning btn-lg"
            onClick={handleLaunchClick}
          >
            Launch Now!
          </button>
        ) : (
          <div>
            {/* Show loading bar during the launch process */}
            {!launchSuccess && (
              <div className="loading-bar-container">
                <div
                  className="loading-bar"
                  style={{ width: `${loadingProgress}%` }}
                ></div>
              </div>
            )}
            {/* Show success message after the loading bar is full */}
            {launchSuccess && (
              <div className="launch-success">
                <h2 className="animated-text">Launch Successful!</h2>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

export default App;
